import canViewCart from '@utils/cart/canViewCart';
import getCart from './getCart';

const getCanViewCart = state => {
  const cart = getCart(state);
  return cart ? canViewCart(cart) : false;
};

export default getCanViewCart;
